// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PK8b","top":"styles_top__3EkJH","left":"styles_left__2M39v","description":"styles_description__1qkAG"};